appSocial.component('leaderFunds', {
    templateUrl: 'widgets/leader-copy/components/leader-funds/LeaderFundsComponent.html',
    bindings: {
        trader: '<',
        action: '<',
        onSuccess: '&',
        onStart: '&',
        onFail: '&',
        onValidation: '&'
    },
    controller: [
        '$scope',
        'SocialUserService',
        'SocialLocaleService',
        'SocialFavoriteService',
        'SocialPortfolioService',
        'SocialUtils',
        'SocialConstants',
        'SocialTypes',
        'LeaderCopyService',
        '$timeout',
        '$filter',
        class LeaderFundsComponent {
            constructor(
                $scope,
                SocialUserService,
                SocialLocaleService,
                SocialFavoriteService,
                SocialPortfolioService,
                SocialUtils,
                SocialConstants,
                SocialTypes,
                LeaderCopyService,
                $timeout,
                $filter
            ) {

                /**
                 * @type {SocialUserService}
                 */
                this.userService = SocialUserService;

                /**
                 * @type {SocialFavoriteService}
                 */
                this.favoriteService = SocialFavoriteService;

                /**
                 * @type {SocialPortfolioService}
                 */
                this.portfolioService = SocialPortfolioService;

                /**
                 * @type {LeaderCopyService}
                 */
                this.leaderCopyService = LeaderCopyService;

                /**
                 * @type {SocialUtils}
                 */
                this.utils = SocialUtils;

                this.actions = SocialTypes.CopyAction;

                this.validationTypes = SocialTypes.ValidationTypes;

                this.$timeout = $timeout;

                this.currencyConvertPipe = $filter('currencyConvert');

                this.currencyPipe = $filter('cryptoCurrency');

                this.translation = SocialLocaleService.translation;

                this.user = this.userService.get();

                this.defaultAmount = 1000; //in USD

                this.amount = {
                    value: this.defaultAmount
                };

                // for stoploss change only
                this.stopLossAmount = {
                    value: 10
                }

                this.watchAddAction = $scope.$on(this.actions.AddFunds, () => this.callAction(this.actions.AddFunds));
                this.watchRemoveAction = $scope.$on(this.actions.RemoveFunds, () => this.callAction(this.actions.RemoveFunds));
                this.watchStopLossAction = $scope.$on(this.actions.SetStopLoss, () => this.stopLossAction());
            }


            $onInit() {
                this.maxAmount = this.calcAmount();

                if (this.action === this.actions.RemoveFunds) {
                    this.amount.value = 250;
                }

                // TODO - check this rule
                if (this.amount.value > this.maxAmount) {
                    this.amount.value = Math.round(this.maxAmount / 100) * 100;
                }

                this.amountConfig = {
                    min: this.action === this.actions.AddFunds
                        ? 250
                        : 1,
                    max: this.action === this.actions.AddFunds
                        ? this.maxAmount
                        : (this.maxAmount - 250),
                    digits: 0,
                    step: 50,
                    label: this.action === this.actions.AddFunds
                        ? 'Amount to add'
                        : 'Amount to remove',
                    strictValidation: false
                }

                this.stopLossConfig = {
                    min: 10,
                    max: 90,
                    digits: 0,
                    step: 10,
                    speedStep: 10,
                    label: 'Stop Loss',
                    valueType: 'number',
                    valueLabel: '%',
                    buttons: true,
                    readonly: false,
                };


                this.stopLoss = this.trader.followStopLoss * 100 / this.trader.followDeposit;
                this.stopLossAmount.value = this.stopLoss;
            }

            $onDestroy() {
                this.watchAddAction && this.watchAddAction();
                this.watchRemoveAction && this.watchRemoveAction();
                this.watchStopLossAction && this.watchStopLossAction();
            }

            /**
             * @param {CopyAction} action
             * @return {Promise<any>}
             */
            callAction(action) {
                const amountInUserCurrency = Number(this.currencyConvertPipe(this.amount.value, 'USD', this.user.currency));
                const amountToUpdate =
                    action === this.actions.AddFunds
                        ? this.trader.followDeposit + amountInUserCurrency
                        : this.trader.followDeposit - amountInUserCurrency;

                this.onStart();

                return this.leaderCopyService.updateFunds(this.trader.followId, amountToUpdate, this.stopLoss)
                    .then(() => {
                        this.onSuccess({amount: this.amount.value});
                    })
                    .catch(err => {
                        this.onFail({error: err});
                    });
            }

            stopLossAction() {
                console.log({
                    followId: this.trader.followId,
                    followDeposit: this.trader.followDeposit,
                    stopLoss: this.stopLossAmount.value
                })
                this.onStart();
                return this.leaderCopyService.updateFunds(this.trader.followId, this.trader.followDeposit, this.stopLossAmount.value)
                    .then(() => {
                        this.onSuccess();
                    })
                    .catch(err => {
                        this.onFail({error: err});
                    });
            }

            calcAmount() {
                if (this.action === this.actions.RemoveFunds) {
                    return this.currencyConvertPipe(this.trader.followDeposit, this.user.currency, 'USD');
                }
                return this.currencyConvertPipe(this.user.balance - this.portfolioService.sumFollowBalance, this.user.currency, 'USD');
            }

            onAmountChange() {
                if (this.action === this.actions.SetStopLoss) {
                    if (this.stopLossAmount.value < this.stopLossConfig.min) {
                        this.validationMessage = `${this.translation.minStopLoss} ${this.stopLossConfig.min}%`;
                        this.onValidation({error: this.validationTypes.MinAmount});
                        return;
                    }
                    this.validationMessage = '';
                    this.onValidation();
                    return;
                }


                // validate amount
                if (this.amount.value < this.amountConfig.min) {
                    this.validationMessage = `${this.translation.minAmount} ${this.currencyPipe(this.amountConfig.min, 'USD')}`;
                    this.onValidation({error: this.validationTypes.MinAmount});
                    return;
                }

                if (this.amount.value > this.amountConfig.max) {
                    this.validationMessage = `${this.translation.maxAmount} ${this.currencyPipe(this.amountConfig.max, 'USD')}`;

                    if (this.action === this.actions.RemoveFunds) {
                        this.onValidation({error: this.validationTypes.MaxAmount});
                        return;
                    }

                    this.onValidation({error: this.validationTypes.Balance});
                    return;
                }

                // any other case - validation success
                this.validationMessage = '';
                this.onValidation();
            }
        }]
})
